(() => {
  if (window.__jfEventGalleryInitialized) return;
  window.__jfEventGalleryInitialized = true;

  const lockScroll = () => { document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; };
  const unlockScroll = () => { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; };

  const getGallery = (dialog) => dialog.closest('[data-jf-event-gallery]');
  const getTiles = (dialog) => Array.from(getGallery(dialog)?.querySelectorAll('[data-jf-gallery-open]') || []);

  const showImage = (dialog, index) => {
    const tiles = getTiles(dialog);
    if (!tiles.length) return;
    const nextIndex = (index + tiles.length) % tiles.length;
    const tile = tiles[nextIndex];
    const image = dialog.querySelector('[data-jf-gallery-image]');
    if (!image) return;
    dialog.dataset.activeIndex = String(nextIndex);
    image.src = tile.dataset.fullSrc;
    image.alt = tile.dataset.alt || '';
    const showNavigation = tiles.length > 1;
    dialog.querySelectorAll('[data-jf-gallery-prev], [data-jf-gallery-next]').forEach((button) => {
      button.hidden = !showNavigation;
    });
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-jf-gallery-open]');
    if (open) {
      const gallery = open.closest('[data-jf-event-gallery]');
      const dialog = gallery?.querySelector('[data-jf-gallery-dialog]');
      if (!dialog) return;
      const tiles = getTiles(dialog);
      showImage(dialog, tiles.indexOf(open));
      if (!dialog.open) dialog.showModal();
      lockScroll();
      return;
    }

    const close = event.target.closest('[data-jf-gallery-close]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }

    const nav = event.target.closest('[data-jf-gallery-prev], [data-jf-gallery-next]');
    if (nav) {
      const dialog = nav.closest('dialog');
      const direction = nav.matches('[data-jf-gallery-next]') ? 1 : -1;
      showImage(dialog, Number(dialog.dataset.activeIndex || 0) + direction);
      return;
    }

    if (event.target.matches('[data-jf-gallery-dialog]')) {
      event.target.close();
    }
  });

  let swipeStart = null;

  document.addEventListener('touchstart', (event) => {
    const dialog = event.target.closest('[data-jf-gallery-dialog]');
    swipeStart = null;
    if (!dialog?.open || getTiles(dialog).length < 2 || event.touches.length !== 1) return;
    if (event.target.closest('button')) return;
    swipeStart = { dialog, x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    if (!swipeStart || event.changedTouches.length !== 1) return;
    const { dialog, x, y } = swipeStart;
    swipeStart = null;
    if (!dialog.open) return;
    const dx = event.changedTouches[0].clientX - x;
    const dy = event.changedTouches[0].clientY - y;
    if (Math.abs(dx) < 50 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;
    showImage(dialog, Number(dialog.dataset.activeIndex || 0) + (dx < 0 ? 1 : -1));
  }, { passive: true });

  document.addEventListener('touchcancel', () => { swipeStart = null; }, { passive: true });

  document.addEventListener('close', (event) => {
    if (event.target.matches?.('[data-jf-gallery-dialog]')) unlockScroll();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const dialog = Array.from(document.querySelectorAll('[data-jf-gallery-dialog]')).find((item) => item.open);
    if (!dialog || getTiles(dialog).length < 2) return;
    event.preventDefault();
    showImage(dialog, Number(dialog.dataset.activeIndex || 0) + (event.key === 'ArrowRight' ? 1 : -1));
  });
})();
